import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "use-socket.io-client";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  CRYPTO_SECRET_KEY,
  getEventStatusText,
  URLS,
  SOCKET_URL,
  SOCKET_CHANNEL,
  INSIDERODEO_EVENT_STORAGE,
  RODEPICK_NEXT_GAME_IDS,
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import clsx from "clsx";
import Sponsor from "src/components/common/Sponsor";
import UpdateDOBModal from "../modal/updateDOBModal";
import LeagueCodeModal from "../modal/leagueCodeModal";
import DaysheetModal from "../modal/daysheetModal";
const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventGamePage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userDetails = useAppUserDetailsSelector();
  const eventGameListSelector = useAppEventGameListSelector();
  const [loginReq, setLoginReq] = useState<any>(0);
  const { eventId, performanceId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const [isEnableDob, setIsEnableDob] = useState<any>(0);
  const [showDOBModal, setShowDOBModal] = useState<boolean>(false);
  const [showLeagueCodeModal, setShowLeagueCodeModal] = useState<boolean>(false);
  const [encryptedGameId, setEncryptedGameId] = useState<any>();
  const [leagueCodeDetails, setLeagueCodeDetails] = useState<any>();
  const [performanceInfo, setPerformanceInfo] = useState<any>();

  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);

  const [showDaysheetModal, setShowDaysheetModal] = useState<boolean>(false);

  const openDaysheetModal = () => {
    setShowDaysheetModal(true);
  };

  const closeDaysheetModal = () => {
    setShowDaysheetModal(false);
  };

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  useEffect(() => {
    // if (userDetails) {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      eventAction.pushGameStatusChangeSocketDataIntoGameList(changeEventStatus);
    });

    //Status Message Change Socket
    // socket.on(SOCKET_CHANNEL.STATUS_MESSAGE, (statusMessage: any) => {
    //     console.log({statusMessage})
    //     eventAction.pushGameStatusMessageSocketDataIntoStatusList(statusMessage, userDetails.id)
    // });
    // }

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      if (changeEventStatus && changeEventStatus.rodeo_event_id && guestUserId) {
        //   console.log(changeEventStatus.rodeo_event_id)
        // setShowGuestSaveVoteModal(true)
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const getEventGameList = () => {
    const params: any = {
      rodeo_event_id: e_id,
      game_id: eventListSelector?.game_details.id,
      performance_id: parseInt(cryptr.decrypt(performanceId)),
    };
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      }
    }
    eventApi.callGetEventGameList(
      params,
      (message: string, resp: any) => {
        // console.log({resp})
        if (resp?.rodeo_event_dtls?.login_required) {
          // eventAction.updateLoginRequired(resp.rodeo_event_dtls.login_required)
          setLoginReq(resp.rodeo_event_dtls.login_required);
        }
        if (resp?.event_dtls?.length) {
          if (resp?.event_dtls[0]?.performance_dtls) {
            setPerformanceInfo(resp?.event_dtls[0]?.performance_dtls);
          }
          if (resp?.event_dtls[0]?.performance_dtls?.is_enable_dob == 1) {
            setIsEnableDob(1);
          } else {
            setIsEnableDob(0);
          }
        }
        if (resp?.event_dtls[0]?.performance_dtls?.is_enable_league_code == "1") {
          setLeagueCodeDetails({
            league_code_details: resp?.league_code_details,
            is_enable_league_code: resp?.event_dtls[0]?.performance_dtls?.is_enable_league_code,
          });
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goToGameDetailsPage = (e: any, game: number) => {
    e.preventDefault();
    const gameId = cryptr.encrypt(game);
    if (isEnableDob == 1 && !userDetails?.dob) {
      openDOBModal();
      setEncryptedGameId(gameId);
      return;
    }
    history.push(`/event/${eventId}/${performanceId}/${gameId}`);
  };

  const openLeagueCodeModal = () => {
    setShowLeagueCodeModal(true);
  };

  const closeLeagueCodeModal = (resp: any) => {
    setShowLeagueCodeModal(false);
    getEventGameList();
  };

  const openDOBModal = () => {
    setShowDOBModal(true);
  };

  const closeDOBModal = () => {
    setShowDOBModal(false);
    history.push(`/event/${eventId}/${performanceId}/${encryptedGameId}`);
  };

  useEffect(() => {
    getEventGameList();
  }, []);

  useEffect(() => {
    if (userDetails || loginReq == 0) {
      // history.push(`/event/${eventId}`)
    } else {
      history.push(`${URLS.LOGIN}`);
    }
  }, [loginReq]);

  useEffect(() => {
    if (eventGameListSelector && eventGameListSelector.length) {
      localStorage.setItem(
        RODEPICK_NEXT_GAME_IDS,
        eventGameListSelector.map((x: any) => JSON.stringify(x.id))
      );
    }
  }, [eventGameListSelector]);

  const goToLeaderBoardPage = (e: any) => {
    e.preventDefault();
    history.push(`/result/${eventId}/${performanceId}`);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      {showLeagueCodeModal && (
        <LeagueCodeModal
          onClose={closeLeagueCodeModal}
          shouldShow={showLeagueCodeModal}
          rodeoEventId={e_id + ""}
          performanceId={cryptr.decrypt(performanceId)}
        />
      )}

      <h2 className="top-two-btns has-leaderboard">
        {/* {
                    !isInsideRodeoTokenExists ?
                        <Link to={URLS.HOME} className="back-history">
                            <img src="/images/left-white.svg" alt="back" />
                        </Link> : null
                } */}

        {/* <span className="page-title text-left">List of Events</span> */}
        {!isInsideRodeoTokenExists ? (
          <Link to={URLS.HOME} className="dual-btn">
            Events
          </Link>
        ) : null}

        {/* <img src='/images/CC-Plus-logo.png' height="35px" alt="cc+"/> */}

        <Link to="#" className="dual-btn" onClick={(e) => goToLeaderBoardPage(e)}>
          Leaderboard
        </Link>
      </h2>
      <hr className="color-white" />
      <div className="ready-msg-wrap">
        {/* <a onClick={goBack} className="back-history">
                    <img src="/images/left-white.svg" alt="back" />
                </a> */}
        Pick your favorite to win the event
      </div>
      {performanceInfo?.document_link ? (
        // <h2 className=" has-leaderboard d-flex justify-content-center mb-3">
        //   <button className="dual-btn" onClick={openDaysheetModal}>
        //     Daysheet
        //   </button>
        // </h2>
        <div className="text-center text-white mb-3">
          <button
            className="rkmd-btn btn-lg btn-orange ripple-effect"
            style={{ width: "130px" }}
            onClick={openDaysheetModal}
          >
            Daysheet
          </button>
        </div>
      ) : null}

      {userDetails && leagueCodeDetails ? (
        <div className="text-center text-white mb-3">
          {leagueCodeDetails?.is_enable_league_code && leagueCodeDetails?.league_code_details?.league_info?.code ? (
            "MY LEAGUE CODE: " + leagueCodeDetails?.league_code_details?.league_info?.code
          ) : (
            <button
              className="rkmd-btn btn-lg btn-orange ripple-effect"
              style={{ width: "130px" }}
              onClick={openLeagueCodeModal}
            >
              Join League
            </button>
          )}
        </div>
      ) : null}
      <ul className="list-style rodeo-inside-list">
        {eventGameListSelector && eventGameListSelector.length ? (
          eventGameListSelector.map((event: any) => (
            <li
              key={event?.id}
              className={clsx({
                voted: event?.ispicked,
              })}
            >
              <Link
                to=""
                className={clsx({
                  "ripple-effect not-started-yet d-flex": event?.status === 0,
                  "ripple-effect on-going-game d-flex": event?.status === 1,
                  "ripple-effect event-end d-flex": event?.status === 2,
                })}
                onClick={(e) => goToGameDetailsPage(e, event?.id)}
              >
                {/* <em>
                    {
                      getEventStatusText(event?.status)
                    }
                  </em> */}
                <span className="event-img">
                  {/* <img src={event?.rodeo_pick_event && event?.rodeo_pick_event?.avatar ? event?.rodeo_pick_event?.avatar?.original : '/images/no-image.png'} alt={`event-${event?.rodeo_pick_event?.title}`} /> */}
                  <img
                    src={
                      event?.event_truck?.id != 0
                        ? event?.event_truck?.thumb
                        : event?.rodeo_pick_event?.avatar
                        ? event?.rodeo_pick_event?.avatar?.thumb
                        : "/images/no-image.png"
                    }
                    alt={`event-${event?.rodeo_pick_event?.title}`}
                  />
                </span>
                <span className="event-info">
                  <span className="d-inline-block event-title">
                    {event?.event_name || event?.rodeo_pick_event?.title}
                  </span>
                </span>
                {/* {
                  event?.sponsor && event?.sponsor?.sponsor && event?.sponsor?.sponsor?.original ?
                    <span className="sponser-img">
                        <img src={event?.sponsor && event?.sponsor?.sponsor && event?.sponsor?.sponsor?.original} alt={`sponsor-${event?.sponsor?.title}`} />
                    </span> : null
              } */}
              </Link>
            </li>
          ))
        ) : (
          <div className="no-text text-white text-center">No events available</div>
        )}
      </ul>
      <Sponsor />

      {showDaysheetModal && performanceInfo?.document_link && (
        <DaysheetModal shouldShow={showDaysheetModal} onClose={closeDaysheetModal} performanceInfo={performanceInfo} />
      )}
      {showDOBModal && encryptedGameId && <UpdateDOBModal onClose={closeDOBModal} shouldShow={showDOBModal} />}
    </React.Fragment>
  );
}
